import { BCMSCurrency } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from "compid/custom-ui/CustomSelect";
import { DatePickerView } from "compid/ui/DatePicker";
import UIAmountInput from "compid/ui/UIAmountInput";
import UINumberInput from "compid/ui/UINumberInput";
import UITextInput from "compid/ui/UITextInput";
import { SVGAsset } from "res";

export default function NonEBillForm(props) {
    const workflowStep = props.workflowStep ?? {};

    const autopay = workflowStep.read("autopay");
    const biller = workflowStep.read("biller");

    const finalDeliveryDate = autopay.finalDeliveryBy.isPast() ? "" : autopay.finalDeliveryBy;
    const lastPaymentAmount = parseFloat(autopay.lastPaymentAmount.amount) === 0 || autopay.lastPaymentAmount.amount === undefined
        ? "" : autopay.lastPaymentAmount.format();

    const onAutopayChange = prop => value => workflowStep.update([ "autopay", prop ], value);
    const onLastAmount = value => workflowStep.update([ "autopay", "lastPaymentAmount" ], BCMSCurrency.init(value.replace("$", "")));
    const finalDeliveryConditionalDisable = date => date.isBefore(autopay.deliverBy);

    return (
        <>
            <div className="form-row flex-height frequency-row custom-select-form-row">
                <CustomSelect label="Frequency" helpText=" " value={ autopay.frequency } onChange={ onAutopayChange("frequency") } dataPoint="Add_Autopay_Frequency">
                    <CustomSelectItem dataPoint="Add_Autopay_Frequency_Weekly">Weekly</CustomSelectItem>
                    <CustomSelectItem dataPoint="Add_Autopay_Frequency_Every_2_Weeks">Every 2 Weeks</CustomSelectItem>
                    <CustomSelectItem dataPoint="Add_Autopay_Frequency_Every_4_Weeks">Every 4 Weeks</CustomSelectItem>
                    <CustomSelectItem dataPoint="Add_Autopay_Frequency_Monthly">Monthly</CustomSelectItem>
                    <CustomSelectItem dataPoint="Add_Autopay_Frequency_Twice_a_Month">Twice a month</CustomSelectItem>
                    <CustomSelectItem dataPoint="Add_Autopay_Frequency_Every_2_Months">Every 2 months</CustomSelectItem>
                    <CustomSelectItem dataPoint="Add_Autopay_Frequency_Every_3_Months">Every 3 months</CustomSelectItem>
                    <CustomSelectItem dataPoint="Add_Autopay_Frequency_Every_6_Months">Every 6 months</CustomSelectItem>
                    <CustomSelectItem dataPoint="Add_Autopay_Frequency_Annually">Annually</CustomSelectItem>
                </CustomSelect>

                <div className="flex-container flex-horizontal align-center">
                    <span className="blue-text sub-text">About frequencies</span>
                    <SVGAsset id="UpsellIcon" className="blue-icon right-icon" />
                </div>
            </div>

            <div className="form-row flex-height duration-row custom-select-form-row">
                <CustomSelect label="Duration" helpText=" " value={ autopay.duration } onChange={ onAutopayChange("duration") } dataPoint="Add_Autopay_Duration">
                    <CustomSelectItem dataPoint="Add_Autopay_Duration_Stop_Payments">Until I stop payments</CustomSelectItem>
                    <CustomSelectItem dataPoint="Add_Autopay_Duration_Specific_Date">Until a specific date</CustomSelectItem>
                    <CustomSelectItem dataPoint="Add_Autopay_Duration_Specific_Number">For a specific number of payments</CustomSelectItem>
                </CustomSelect>
            </div>

            { autopay.duration === "Until a specific date" &&
                <div className="form-row flex-height">
                    <DatePickerView dateLabel="Final delivery date" setDate={ finalDeliveryDate } onChange={ onAutopayChange("finalDeliveryBy") } billerType={ biller.paymentType } conditionalDisable={ finalDeliveryConditionalDisable }>
                        <span className="sub-text">Payments that fall on a weekend or holiday will be changed to previous business day.</span>
                    </DatePickerView>
                </div> }
            
            { autopay.duration === "For a specific number of payments" &&
                <div className="form-row flex-height">
                    <UINumberInput placeHolder="Number of payments" value={ autopay.numberOfPayments } onChange={ onAutopayChange("numberOfPayments") } />
                </div> }
            
            { (autopay.duration === "Until a specific date" || autopay.duration === "For a specific number of payments") &&
                <div className="form-row flex-height last-payment-row">
                    <UIAmountInput placeHolder="Amount of last payment (optional)" value={ lastPaymentAmount } onChange={ onLastAmount } />

                    <div className="flex-container flex-horizontal align-center space-between">
                        <span className="sub-text">If different than amount of other payments</span>
                    </div>
                </div> }
        </>
    );
}